import { API_BASE_URL } from "../environment";

export const updateChatIntegrationStatus = async (tenantId: string | number): Promise<boolean> => {
    try {
        const auth = JSON.parse(localStorage.getItem("authResponse") || "{}");
        const userId = auth?.user_id || "";
        const response = await fetch(
            `${API_BASE_URL}/external-chat-tenant-bot/?tenant_id=${tenantId}&is_deleted=false&is_active=true${userId ? `&created_by=${userId}` : ""}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Basic ${localStorage.getItem("authCred")}`,
                },
            }
        );

        if (!response.ok) {
            localStorage.setItem("chatIntegration", "false");
            return false;
        }

        const data = await response.json();
        const bots = data.results || data || [];

        const hasValidBot = bots.some(
            (bot: any) =>
                (bot.bot_key && bot.bot_message_webhook_url && bot.bot_id) ||
                bot.seller_id
        );

        localStorage.setItem("chatIntegration", hasValidBot.toString());
        return hasValidBot;
    } catch (error) {
        localStorage.setItem("chatIntegration", "false");
        return false;
    }
};
